/* aurapik wishlist — localStorage, keyed by product handle. No login required. */
(function () {
  const KEY = 'aurapik_wishlist';
  const get = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  };
  const save = (a) => localStorage.setItem(KEY, JSON.stringify([...new Set(a)]));

  function paint() {
    const ids = get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((b) => {
      b.setAttribute('aria-pressed', ids.includes(b.getAttribute('data-wishlist-toggle')) ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = ids.length;
      el.hidden = ids.length === 0;
    });
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    const h = b.getAttribute('data-wishlist-toggle');
    const ids = get();
    const i = ids.indexOf(h);
    if (i >= 0) ids.splice(i, 1);
    else ids.push(h);
    save(ids);
    paint();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { ids } }));
  });

  document.addEventListener('DOMContentLoaded', paint);
  window.aurapikWishlist = { get, paint };
})();
